<template>
  <v-layout align-end justify-end>
    <v-menu bottom left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          v-bind="attrs"
          v-on="on"
          @click.stop
        >
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <div v-for="(actionColumn, key) in actionColumns" :key="key" v-if="handleColumn(actionColumn.category)">
          <v-list-item @click="onActionButtonClick(actionColumn.category)" :disabled="disabled(actionColumn, row)">
            <v-list-item-action>
              <v-icon :color="actionColumn.color || 'primary' ">{{actionColumn.icon}}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{actionColumn.text}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-list>
    </v-menu>
  </v-layout>
</template>

<script>
  export default {
    name: 'RowActionMenuButton',
    props: {
      disabled: {
        type: Function,
        default: function (actionColumn = {}, row = {}) {
          return false;
        }
      },
      row: {
        type: Object,
        default: function () {
          return {};
        },
      },
      actionColumns: {
        type: Array,
        default: function () {
          return [];
        }
      },
      column: {
        type:Object,
        default: () => ({})
      },
      user: {
        type:Object,
        default: () => ({})
      },
    },
    methods: {
      onActionButtonClick (category) {
        this.$emit('actionButtonClick', {
          row: this.row,
          category
        })
      },
      handleColumn(text) {
        if(this.column.isDeleted) {
          return !(text.toLowerCase() === 'delete' || text.toLowerCase() === 'edit' || text.toLowerCase() === 'resendmail' || text.toLowerCase() === 'mergedmail' || text.toLowerCase() === 'updatemergedmail');
        } else if(this.column.paymentStatus === 200) {
          if(this.user && this.user.role_id === 1 && text.toLowerCase() === 'refund') return true;
          if(this.user && this.user.role_id !== 1 && text.toLowerCase() === 'deletepermanent') return false;
          return !(text.toLowerCase() === 'credit' || text.toLowerCase() === 'resendmail' || text.toLowerCase() === 'restore' || text.toLowerCase() === 'reset' || text.toLowerCase() === 'merged' || text.toLowerCase() === 'mergedmail' || text.toLowerCase() === 'updatemergedmail');
        } else if(this.column.paymentStatus === 100) {
          if(text.toLowerCase() === 'refund') return false;
          if(this.user && this.user.role_id === 1 && text.toLowerCase() === 'refund') return false;
          if(this.user && this.user.role_id !== 1 && text.toLowerCase() === 'deletepermanent') return false;
          if(!(this.user && this.user.role_id === 1 || this.user.email === "saykatzetrank@gmail.com") && text.toLowerCase() === 'credit') return false;
          return !(text.toLowerCase() === 'restore' || text.toLowerCase() === 'reset')
        } else if(this.user && this.user.role_id !== 1 && text.toLowerCase() === 'deletepermanent') {
          return false;
        } else if(text.toLowerCase() === 'refund') {
          return false;
        }
        return true;
      }
    }
  }
</script>

<style scoped>

</style>
